/**
 * ESM view of the Greek casing rules.
 *
 * The implementation lives in greek.cjs so the CommonJS backend and the bundled
 * frontends share exactly one copy — the rules are subtle enough that two
 * implementations would drift.
 */
import greek from './greek.cjs';

export const toGreekUpper = greek.toGreekUpper;
export const upper = greek.upper;
export default greek.toGreekUpper;
